<template>
  <div class="item">
			<template slot="button-content">
        <i class="zmdi zmdi-power"></i>
      </template>

    
    <div class="id">{{ source.id }} - {{ source.item }}</div>
  </div>
</template>

<script>
export default {
  name: 'Item',
  props: {
    source: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>

<style scoped>
.item {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid lightgrey;
  padding: 1em;
}
</style>
